import autobind from 'autobind-decorator';
import * as React from 'react';
import { ConstantFunctions } from '../../utils/constant-functions';
import { MovableContextMenu } from './movable-context-menu';

export enum ContextMenuPositionMode {
  ContainerCenter,
  MousePosition,
}

interface Props {
  disabled?: boolean;
  renderContextMenuContent: () => React.ReactNode;
  positionMode?: ContextMenuPositionMode;
}

interface State {
  menuPosition: { x: number, y: number };
}

export class ContainerWithContextMenu extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      menuPosition: null,
    };
  }

  public render(): React.ReactNode {
    if (this.props.disabled) {
      return this.props.children;
    }
    return (
      <>
        <div onContextMenu={this.onContextClick}>
          {this.props.children}
        </div>
        {
          this.state.menuPosition ? (
            <MovableContextMenu
              x={this.state.menuPosition.x}
              y={this.state.menuPosition.y}
              onClose={this.onCloseMenu}
              zIndex={1003}
            >
              {this.props.renderContextMenuContent()}
            </MovableContextMenu>
          ) : null
        }
      </>
    );
  }

  @autobind
  private onCloseMenu(): void {
    this.setState({ menuPosition: null });
  }

  @autobind
  private onContextClick(e: React.MouseEvent<HTMLDivElement>): void {
    ConstantFunctions.stopEvent(e);
    if (this.props.positionMode === ContextMenuPositionMode.MousePosition) {
      this.setPositionByMouse(e);
    } else {
      this.setPositionByTargetCenter(e);
    }
  }

  private setPositionByMouse(e: React.MouseEvent<HTMLDivElement>): void {
    this.setState({ menuPosition: { x: e.clientX, y: e.clientY } });
  }

  private setPositionByTargetCenter(e: React.MouseEvent<HTMLDivElement>): void {
    const { top, left, height, width } = e.currentTarget.getBoundingClientRect();
    const x = left + width / 2;
    const y = top + height / 2;
    this.setState({ menuPosition: { x, y } });
  }
}
